import { render, staticRenderFns } from "./TenantAmount.vue?vue&type=template&id=38554348&"
import script from "./TenantAmount.vue?vue&type=script&lang=js&"
export * from "./TenantAmount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports